// extracted by mini-css-extract-plugin
export default {"root":"PlasmicSearchRectangle_root__7hnA7","roottestVariant":"PlasmicSearchRectangle_roottestVariant__z4Eab"};